import { default as BaseLink } from '@mui/joy/Link';
import { forwardRef, type JSX } from 'react';
import { clsx } from 'clsx';
import { slowCn } from '../../lib/utils';
import type { LinkProps } from './types';
import { linkDecoratorVariants, linkTextVariants, linkVariants } from './styles';

const LINK_ID_CLASSNAME = 'ua-link';

const Link = forwardRef<HTMLAnchorElement, LinkProps>((props, ref): JSX.Element => {
  const {
    size = 'md',
    color,
    startDecoratorComponent: StartDecoratorComponent,
    startDecoratorNode,
    endDecoratorComponent: EndDecoratorComponent,
    endDecoratorNode,
    className,
    decoratorClassName,
    underline,
    resolveUrl, // eslint-disable-line @typescript-eslint/no-unused-vars -- used in native
    ...rest
  } = props;

  const linkTextClassName = linkTextVariants({
    size,
    underline,
  });
  const linkClassName = linkVariants({
    className: slowCn(LINK_ID_CLASSNAME, linkTextClassName, className),
    size,
  });

  const linkDecoratorClassName = linkDecoratorVariants({
    size,
  });

  const startDecorator = StartDecoratorComponent ? (
    <StartDecoratorComponent className={clsx(linkDecoratorClassName, decoratorClassName)} />
  ) : (
    startDecoratorNode
  );

  const endDecorator = EndDecoratorComponent ? (
    <EndDecoratorComponent className={clsx(linkDecoratorClassName, decoratorClassName)} />
  ) : (
    endDecoratorNode
  );

  return (
    <BaseLink
      ref={ref}
      {...rest}
      className={linkClassName}
      data-color={color}
      data-size={size}
      endDecorator={endDecorator}
      startDecorator={startDecorator}
      underline={underline}
    />
  );
});

Link.displayName = 'Link';

export default Link;
